import React from "react";

/**
 * SearchHighlight - Renders yellow highlight boxes over matched text in PDF pages
 */
export default function SearchHighlight({ matches, pageIndex, canvasWidth, canvasHeight, activeMatchId }) {
  if (!matches || matches.length === 0) return null;

  // Filter matches for this specific page
  const pageMatches = matches.filter(m => m.pageIndex === pageIndex);
  if (pageMatches.length === 0) return null;

  return (
    <div 
      className="fb-search-highlight-layer"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 3,
      }}
    >
  {pageMatches.map((match, matchIdx) => 
        match.items.map((item, itemIdx) => {
          // Calculate position as percentage of canvas dimensions
          const leftPct = (item.x / canvasWidth) * 100;
          const topPct = (item.y / canvasHeight) * 100;
          const widthPct = (item.width / canvasWidth) * 100;
          const heightPct = (item.height / canvasHeight) * 100;
          // Highlight the globally active occurrence in orange
          const isActive = activeMatchId !== undefined && match.id === activeMatchId;
          const bgColor = isActive ? "rgba(255, 140, 0, 0.45)" : "rgba(255, 255, 0, 0.35)";
          const outlineColor = isActive ? "rgba(255, 120, 0, 0.8)" : "rgba(255, 200, 0, 0.5)";
          
          return (
            <div
              key={`${matchIdx}-${itemIdx}`}
              className="fb-search-highlight-box"
              style={{
                position: "absolute",
                left: `${leftPct}%`,
                top: `${topPct}%`,
                width: `${widthPct}%`,
                height: `${heightPct}%`,
                backgroundColor: bgColor,
                outline: `1px solid ${outlineColor}`,
                boxSizing: "border-box",
                pointerEvents: "none",
                mixBlendMode: "multiply",
              }}
            />
          );
        })
      )}
    </div>
  );
}
